import { render, staticRenderFns } from "./navigating.vue?vue&type=template&id=38c22780&scoped=true&"
import script from "./navigating.vue?vue&type=script&lang=js&"
export * from "./navigating.vue?vue&type=script&lang=js&"
import style0 from "./navigating.vue?vue&type=style&index=0&id=38c22780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c22780",
  null
  
)

export default component.exports